var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbdownDoubleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8344 2.22949H5.41107C5.05045 2.22949 4.69956 2.34646 4.41107 2.56283C4.12257 2.7792 3.91204 3.0833 3.81107 3.42949L1.8694 10.0962C1.79695 10.3446 1.78333 10.6064 1.82962 10.861C1.8759 11.1155 1.98082 11.3558 2.13607 11.5628C2.29131 11.7698 2.49262 11.9378 2.72405 12.0535C2.95547 12.1693 3.21066 12.2295 3.4694 12.2295H8.32773L7.4944 15.6628C7.4002 16.0444 7.39344 16.4423 7.47462 16.8268C7.5558 17.2114 7.72283 17.5726 7.96323 17.8835C8.20363 18.1944 8.51118 18.447 8.8629 18.6223C9.21462 18.7977 9.60142 18.8913 9.9944 18.8962L12.8694 13.1545",
    stroke: "#333333",
    strokeWidth: 1.99943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4944 15.6628L17.3277 12.2295H12.4694C12.2107 12.2295 11.9555 12.1693 11.724 12.0535C11.4926 11.9378 11.2913 11.7698 11.1361 11.5628C10.9808 11.3558 10.8759 11.1155 10.8296 10.861C10.7833 10.6064 10.797 10.3446 10.8694 10.0962L12.8111 3.42949C12.912 3.0833 13.1226 2.7792 13.4111 2.56283C13.6996 2.34646 14.0505 2.22949 14.4111 2.22949H25.6611C26.1031 2.22949 26.527 2.40509 26.8396 2.71765C27.1521 3.03021 27.3277 3.45413 27.3277 3.89616V10.5628C27.3277 11.0049 27.1521 11.4288 26.8396 11.7413C26.527 12.0539 26.1031 12.2295 25.6611 12.2295H23.3611C23.051 12.2297 22.7471 12.3163 22.4836 12.4797C22.2201 12.6431 22.0074 12.8768 21.8694 13.1545L18.9944 18.8962C18.6014 18.8913 18.2146 18.7977 17.8629 18.6223C17.5112 18.447 17.2036 18.1944 16.9632 17.8835C16.7228 17.5726 16.5558 17.2114 16.4746 16.8268C16.3934 16.4423 16.4002 16.0444 16.4944 15.6628Z",
    stroke: "#333333",
    strokeWidth: 1.99943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1602 12.2295V2.22949",
    stroke: "#333333",
    strokeWidth: 1.99943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbdownDoubleIcon);
export default __webpack_public_path__ + "static/media/thumbdown-double-icon.405043f30de05d1154a2c9f51d34f341.svg";
export { ForwardRef as ReactComponent };